import React, { useState, useEffect } from 'react';
import './TextArea.css'; // Assuming you will create a CSS file for styling
import { Globals } from '../../global/Globals';

const TextArea = ({ noCharCounterNeeded=false,clearText=false, textAreaInput, placeHolder,className,maxCharacters,value,validateField,key,tabIndex,onBlur,error,...otherProps }) => {
    const [text, setText] = useState(value || "");
    if(!maxCharacters){
        maxCharacters=Globals.TXT_AREA_MAX_CHARS_LIMIT;
    }
    let extraProps={...otherProps};
    if(tabIndex){
        extraProps.tabindex=tabIndex;
    }
    const handleChange = (event) => {
        if (event.target.value.length <= maxCharacters) {
            setText(event.target.value);
            if(textAreaInput){
                textAreaInput(event.target.value);
            }
           
            if(validateField){
            validateField(key, event.target.value);
            }
        }
        
    };

    useEffect(() => {
        if (clearText) {
            setText("");
        }
    }, [clearText])

    return (
        <div className={`text-area-container`} >
            <textarea
                className={"text-area "+ className || ""}
                value={value || text}
                onChange={handleChange}
                maxLength={maxCharacters}
                placeholder={placeHolder}
                onBlur={ handleChange}
                {...extraProps}
            />
            
            {error?<>
            <div className="char-counter1" style={{display:"flex"}}>
                      {error && <div> <p className="invalidCredential" style={{margin:"0px 3.5px 0px 0px",display:'flex',alignItems:'justify-content'}}> <img id="login-error" className=" error" src={Globals.IMG.ERROR} alt="password error" style={{marginLeft:0,marginTop:"0px"}}/>{error}</p></div>}
                      <div className="char-counter" style={{flex:1}} >{text.length}/{maxCharacters}</div>  
                      </div>
            </>:
            <div className="char-counter">
                    <>{!noCharCounterNeeded && ((value?.length || text.length) + '/' + maxCharacters)}</>
            </div>
}
        </div>
    );
};

export default TextArea;